import React from 'react';

function NavLogo() {
    return (
        <a className="nav-logo-link" href=".">
                <h1 class="nav-logo">Mike Shelby</h1>
        </a>
    );
}

export default NavLogo;